import isEmpty from 'lodash/isEmpty';
import { useAppendDraftComment } from 'pages/WellGuardian/WIR/hooks';
import { getFinalPreparationReactiveScopeData } from 'pages/WellGuardian/WIR/utils';
import { WIRFinalPreparationSections } from 'pages/WellGuardian/WIR/wir.constants';
import { useCallback, useMemo } from 'react';
import { useCountryState, useSelectedWIR } from '../../../../redux/WellGuardian/selectors';
import wellGuardianApiClient from 'services/networking/wellGuardianApiClient';
import { WIR } from 'types/wellGuardian';

export const useSectionIWOPData = () => {
  const wirFromState = useSelectedWIR();
  const { appendDraftComment } = useAppendDraftComment();
  const countryState = useCountryState();

  const assignIWOPPayload = useMemo(() => {
    const { phase, IWOP } = getFinalPreparationReactiveScopeData(wirFromState, countryState);
    const meetingDate = IWOP?.meetingDate;
    const userNameIwop = IWOP?.userNameIwop;
    const userIdIwop = IWOP?.userIdIwop;
    const IwopAttendees = IWOP?.IwopAttendees;
    const comments = appendDraftComment(IWOP?.comments || []);
    const sectionCompleteConfirmation = IWOP?.sectionCompleteConfirmation;

    const isTicked = !isEmpty(userNameIwop) && !isEmpty(userIdIwop);

    return {
      meetingDate,
      userNameIwop,
      userIdIwop,
      IwopAttendees,
      isTicked,
      sectionCompleteConfirmation,
      comments,
      phase,
      lastUpdatedDate: new Date().toISOString(),
      assignedTo: IWOP?.assignedTo || '',
    };
  }, [wirFromState, appendDraftComment, countryState]);

  const saveAssignIWOPSection = useCallback(
    async (section: string, processSaveResponse: (wirResponse: WIR | null) => void) => {
      if (wirFromState?.wirNumber && section === WIRFinalPreparationSections.iwop) {
        processSaveResponse(
          await wellGuardianApiClient.updateWIRIWOPSection(
            wirFromState?.wirNumber,
            assignIWOPPayload,
            countryState,
          ),
        );
      }
    },
    [wirFromState, assignIWOPPayload, countryState],
  );

  return {
    saveAssignIWOPSection,
    assignIWOPPayload,
  };
};
